import * as React from 'react'

import { confirmationPage } from 'components/confirmationPage'
import { defaultErrorProps } from 'components/error-props'

import { NextPage, withErrorPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { InitialProps, Page, Props } from '@grandvisionhq/www-next/pages/reschedule-appointment'

import { withCms, withLayout } from '../cms'
import { getTimeFiltersConfig } from '../configuration'

import '@grandvisionhq/appointments/dist/index.css'

const timeFilterSettings = getTimeFiltersConfig()

export const AppointmentReschedulePage: NextPage<Props, InitialProps> = (props) => {
  return <Page {...props} timeFilterSettings={timeFilterSettings} slots={{ confirmationPage }} />
}

AppointmentReschedulePage.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(
  withCms(),
  withErrorPage(defaultErrorProps),
  withLayout({
    hasOnlyLogoInHeader: true,
    footer: false,
  })
)(AppointmentReschedulePage)
